function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  fill: "#FBDDD8"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 8,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 13a8 8 0 1016 0 8 8 0 00-16 0zm8.826-5h-1.652c-.231-.002-.421.15-.424.341a.29.29 0 000 .02l.38 5.815c.014.184.2.326.424.324h.892c.223.002.41-.14.424-.324l.38-5.816c.01-.19-.17-.352-.402-.36h-.022zM13 18.252a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
  fill: "url(#StatusIcon_svg__paint0_linear_604_10349)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "StatusIcon_svg__paint0_linear_604_10349",
  x1: 5,
  y1: 5,
  x2: 5,
  y2: 21,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F06A57"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#DE2612"
})));

var SvgStatusIcon = function SvgStatusIcon(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgStatusIcon;